
const addproduct = (state, item) => {
    const newstate = state.filter(el => el.item.id === item.id && el.qty++)[0]
    return newstate === undefined ?
        [
            ...state,
            {
                item: item,
                qty: 1
            }
        ]
        :
        [
            ...state
        ]
}

const increasqty = (state, id) => {
    const newstate = state.filter(el => el.item.id === id && el.qty++)[0];
    return newstate !== undefined && [...state]

}

const decreaseqty = (state, id) => {
    const newstate = state.filter(el => el.item.id === id && el.qty--)[0];
    return newstate !== undefined && [...state]

}



const removeitem = (state, id) => {
    const index = state.findIndex((el) => el.item.id === id);
    state.splice(index, 1)
    return [...state]
}


const addtocart = (state = [], action) => {
    switch (action.type) {
        case 'ADDTOCART':
            return addproduct(state, action.item)

        case 'INCREASEQUANTITY':
            return increasqty(state, action.item.id);

        case 'DECREASEQUANTITY':
            return decreaseqty(state, action.item.id);

        case 'REMOVEFROMCART':
            removeitem(state, action.item.id);
            return [...state];


        default:
            return state;
    }
};


export default addtocart;